// extracted by mini-css-extract-plugin
module.exports = {"linksSection":"wavefooter_linksSection__1A63g","nightMode":"wavefooter_nightMode__35D5h","openIt":"wavefooter_openIt__1_8Hh","closeIt":"wavefooter_closeIt__7T6vn"};